import { render, staticRenderFns } from "./batchInvoiceModel.vue?vue&type=template&id=2f2e101e&scoped=true&"
import script from "./batchInvoiceModel.vue?vue&type=script&lang=js&"
export * from "./batchInvoiceModel.vue?vue&type=script&lang=js&"
import style0 from "./batchInvoiceModel.vue?vue&type=style&index=0&id=2f2e101e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e101e",
  null
  
)

export default component.exports